import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const HeaderWrapper = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;

    @media (max-width: ${breakpoints.xs}px) {
        align-items: flex-start;
    }
`;

export const AnswerDisclosure = styled.button(
    ({ theme: { palette, radius } }) => css`
        align-items: center;
        background-color: ${palette.primary.default};
        border-radius: ${radius[6]}px;
        border: 1px solid ${palette.primary.default};
        cursor: pointer;
        display: flex;
        height: 40px;
        justify-content: center;
        margin: 0;
        width: 40px;

        &:hover {
            background-color: ${palette.primary.hover};
            border-color: ${palette.tertiary.background};
        }
    `,
);

export const Title = styled(Typography.TextH2_28_44)(
    ({ theme: { fontWeight } }) => css`
        @media (max-width: ${breakpoints.md}px) {
            font-weight: ${fontWeight.normal};
            line-height: 36px;
            margin-bottom: 24px;
        }
    `,
);
